// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3692f9d9","455":"937d2056","977":"adafab62"}[chunkId] + ".chunk.js";
};